import { Injectable } from '@angular/core';

import { NdtSnackBar } from '../snack-bar/snack-bar';
import { NotificationComponent } from './notification.component';
import { NotificationActions, NotificationContent, NotificationData } from './notification.interface';
import { NotificationModule } from './notification.module';

@Injectable({
  providedIn: NotificationModule,
})
export class NotificationService {
  constructor(private readonly snackbar: NdtSnackBar) {}

  showError(content?: NotificationContent, actions?: NotificationActions): void {
    this.showNotification({
      ...actions,
      content: {
        label: $localize`Niepowodzenie`,
        message: $localize`Wystąpił błąd.`,
        ...content,
      },
      type: 'error',
    });
  }

  showInfo(content: NotificationContent, actions?: NotificationActions): void {
    this.showNotification({ actions, content, type: 'info' });
  }

  showSuccess(content?: NotificationContent, actions?: NotificationActions): void {
    this.showNotification({
      actions,
      content: {
        label: $localize`Sukces`,
        message: $localize`Pomyślnie wykonano.`,
        ...content,
      },
      type: 'success',
    });
  }

  showWarning(content: NotificationContent, actions?: NotificationActions): void {
    this.showNotification({
      actions,
      content: {
        label: $localize`Ostrzeżenie`,
        ...content,
      },
      type: 'warning',
    });
  }

  showCopied(): void {
    this.showSuccess({ message: $localize`Pomyślnie skopiowano.` });
  }

  showDeleted(): void {
    this.showSuccess({ message: $localize`Pomyślnie usunięto.` });
  }

  showSaved(): void {
    this.showSuccess({ message: $localize`Pomyślnie zapisano.` });
  }

  showUpdated(): void {
    this.showSuccess({ message: $localize`Pomyślnie zaktualizowano.` });
  }

  private showNotification(data: NotificationData): void {
    this.snackbar.openFromComponent(NotificationComponent, {
      data,
      duration: this.getVariableDuration(data.content.message),
    });
  }

  private getVariableDuration(message: string): number {
    return Math.max(this.snackbar.defaultConfig.duration, message.length * 50);
  }
}
